/**
 * GEM backend decrypts identity headers with CryptLib (AES/CBC), which is
 * incompatible with CryptoJS AES output. Send these values as plaintext.
 * CryptLib.decryptData returns the original string when decrypt fails.
 */
export interface GemIdentityHeaders {
  companyId: string;
  userId: string;
  companyName: string;
  uniqueUserId: string;
}

function parseStoredJson(key: string): any {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || raw === 'null' || raw === 'undefined') {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Resolve plain company name (never send companyDetailsGoveva JSON as the header). */
export function getPlainGemCompanyName(companyInfo?: any): string {
  const info = companyInfo || parseStoredJson('companyDetails');
  if (info?.companyName && typeof info.companyName === 'string') {
    return info.companyName;
  }

  const goveva = parseStoredJson('companyDetailsGoveva');
  if (goveva?.label && typeof goveva.label === 'string') {
    return goveva.label;
  }
  if (typeof goveva === 'string') {
    return goveva;
  }

  return '';
}

/** Plaintext identity headers required by GEM APIs. Do not encrypt these. */
export function getPlainGemIdentityHeaders(): GemIdentityHeaders | null {
  const user = parseStoredJson('user');
  const companyInfo = parseStoredJson('companyDetails');

  if (!user?._id || !companyInfo?.companyID) {
    return null;
  }

  return {
    companyId: String(companyInfo.companyID),
    userId: String(user._id),
    companyName: getPlainGemCompanyName(companyInfo),
    uniqueUserId: String(user.UniqueUserId || ''),
  };
}
